<div class="phone-input" [formGroup]="internalForm">
  <!-- Country code autocomplete -->
  <mat-form-field appearance="outline" class="phone-input__code">
    <input
      matInput
      formControlName="phoneCode"
      [matAutocomplete]="codeAuto"
      placeholder="Code"
      [readonly]="codeReadonly"
      (focus)="onCodeFocus()"
      (click)="onCodeInteract(); codeReadonly && autoTrigger.openPanel()"
      (keydown)="onCodeInteract()"
      (blur)="onBlur()"
    />
    <mat-autocomplete
      #codeAuto="matAutocomplete"
      [displayWith]="displayCountryAndCode"
      panelWidth="auto"
    >
      @for (country of filteredCountries | async; track country) {
        <mat-option [value]="country.dial_code">
          <div class="phone-input__option">
            <img
              class="phone-input__flag"
              [src]="country.flagUrl"
              [alt]="country.code"
            />
            <span class="phone-input__option-name">{{ country.name }}</span>
            <span class="phone-input__option-code"
              >({{ country.dial_code }})</span
            >
          </div>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <!-- Phone number -->
  <mat-form-field appearance="outline" class="phone-input__number">
    <input
      matInput
      type="tel"
      formControlName="phoneNumber"
      [placeholder]="placeholder | translate"
      [errorStateMatcher]="phoneErrorMatcher"
      (blur)="onBlur()"
    />
    <!-- <mat-error *ngIf="showRequired">Phone number is required.</mat-error> -->
    <!-- <mat-error *ngIf="showInvalidPhone">Enter a valid phone number.</mat-error> -->
  </mat-form-field>
</div>
